<script lang="ts" setup>
import type { CountryCodeAlpha2 } from '~/types/core';

import { COUNTRY_CODE_ALPHA_2 } from '~/types/core';

interface Props {
  label: string;
  hideLabel?: boolean;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  verified?: boolean;
  baseCountry?: CountryCodeAlpha2;
  version?: 'v1' | 'v2';
}

const props = withDefaults(defineProps<Props>(), {
  hideLabel: false,
  // will show the number format if not passed in
  placeholder: '',
  disabled: false,
  required: false,
  verified: false,
  baseCountry: COUNTRY_CODE_ALPHA_2.US,
  version: 'v1',
});

const emit = defineEmits<{
  'valid': [isValid: boolean];
  'keydown.enter': [];
}>();
const phoneNumber = defineModel<string>({ required: true });
const { getFlag } = useFeatureFlags();
const smsFlag = await getFlag('sms-verification-au-enabled');

const countriesAvailable = computed(() => {
  if (smsFlag) {
    return [COUNTRY_CODE_ALPHA_2.US, COUNTRY_CODE_ALPHA_2.AU];
  }
  return [props.baseCountry];
});

const allowDropDown = computed(() => {
  return smsFlag && !props.disabled;
});
</script>

<!-- eslint-disable vue/custom-event-name-casing -->
<template>
  <div class="relative">
    <KUICoreInputPhoneNumber
      v-model="phoneNumber"
      :label="label"
      :hide-label="hideLabel"
      :verified="verified"
      :placeholder="placeholder"
      :disabled="disabled"
      :separate-dial-code="true"
      :initial-country="props.baseCountry"
      :only-countries="countriesAvailable"
      :allow-dropdown="allowDropDown"
      :required="required"
      container-rounded="lg"
      :version="version"
      :use-full-screen-popup="version === 'v1'"
      @valid="emit('valid', $event)"
      @keydown.enter="emit('keydown.enter')"
    />
  </div>
</template>
